import type { Dependencies } from "@redux/store";
import { createAsyncThunk } from "@reduxjs/toolkit";
import type { UnpaidLessonVM } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const teacherRetrieveUnpaidLessons = createAsyncThunk<UnpaidLessonVM[], void, { extra: Partial<Dependencies> }>(
  "unpaidLessons/teacherRetrieveUnpaidLessons",
  async (_: void, { extra: { teacherRepository } }) => {
    return teacherRepository!.getUnpaidLessons();
  },
);
